import React from 'react';

const useGatherDataFromApi = (
  callOnInitArray,
  customwatcher = null,
  excludefirstrender = false,
  disabled = false
) => {
  const [gatheredData, setGatheredData] =
    React.useState(null);
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    if (disabled) {
      return;
    }
    if (excludefirstrender) {
      if (!isFirstRender.current) {
        //if it should get data from API at initial render
        if (
          callOnInitArray &&
          callOnInitArray instanceof Array
        ) {
          callOnInitArray?.forEach((effectFn) => {
            effectFn?.functions(
              setGatheredData,
              effectFn.parameters
            );
          });
        } else {
          callOnInitArray(setGatheredData);
        }
      }
      isFirstRender.current = true;
    } else {
      //if it should get data from API at initial render
      if (
        callOnInitArray &&
        callOnInitArray instanceof Array
      ) {
        callOnInitArray?.forEach((effectFn) => {
          effectFn?.functions(
            setGatheredData,
            effectFn.parameters
          );
        });
      } else {
        callOnInitArray(setGatheredData);
      }
    }
  }, [
    JSON.stringify(callOnInitArray),
    customwatcher,
    disabled,
  ]);
  const HandleGatherData = (ObjectName, value) => {
    // if the api call must trigger on event
    setGatheredData((prev) => ({
      ...prev,
      [ObjectName]: value,
    }));
  };
  return { HandleGatherData, gatheredData }; //HandleGatherData won't be used if callOnInit is true
};

export default useGatherDataFromApi;
